var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import qs from 'qs';
import getNewCart from './getNewCart';
import addressFieldsModel from '../models/addressFieldsModel';
import getFullFibrePlans from './getFullFibrePlans';
import AppState from '../AppState';
/**
 * Asynchronously retrieves the service qualification based on the provided GNAF ID.
 *
 * @param {boolean|string} gnafId - The GNAF ID to use for the service qualification.
 * @returns {Promise<boolean|PlanData[]>} - A promise that resolves to the object
 *                                          received from the getFullFibrePlans
 *                                          function.
 * @throws {Error} - If there is an error receiving the service qualification.
 */
const getServiceQualification = (gnafId = false) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { vocusApiRootAddressSuggest, onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret } = settings;
    // Obtain the service address object via One Platform.
    const onePlatformServiceQualificationEndpoint = onePlatformApiRoot + vocusApiRootAddressSuggest + '?gnafId=';
    const onePlatformServiceQualificationObject = yield fetch(`${onePlatformServiceQualificationEndpoint}${gnafId}&source=nbn`, {
        headers: {
            'client_id': onePlatformApiClientId,
            'client_secret': onePlatformApiClientSecret
        }
    })
        .then(response => {
        if (!response.ok) {
            return false;
        }
        else {
            return response.json();
        }
    })
        .catch(error => console.log(error));
    if (onePlatformServiceQualificationObject && onePlatformServiceQualificationObject.compositeAddress.length > 0) {
        return {
            onePlatformServiceQualification: onePlatformServiceQualificationObject,
            serviceQualification: false,
            address: {},
            salesId: '',
            token: '',
        };
    }
    return getEstablishedServiceQualification(gnafId);
});
/**
 * Asynchronously retrieves the service qualification based on the provided
 * GNAF ID via established SQ.
 *
 * @param {boolean|string} gnafId - The GNAF ID to use for the service qualification.
 * @returns {Promise<boolean|PlanData[]>} - A promise that resolves to the object
 *                                          received from the getFullFibrePlans
 *                                          function.
 * @throws {Error} - If there is an error receiving the service qualification.
 */
export const getEstablishedServiceQualification = (gnafId = false) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { vocusApiRoot, vocusApiCart, vocusApiSegmentsSqGnafp } = settings;
    // Obtain a new salesID and token.
    const { sales_idField, tokenField } = yield getNewCart(vocusApiRoot, vocusApiCart);
    // Obtain the service address object and filter for required fields.
    const serviceQualificationEndpoint = vocusApiRoot + vocusApiSegmentsSqGnafp + '?organisationType=1&gnafId=';
    const serviceQualificationObject = yield fetch(`${serviceQualificationEndpoint}${gnafId}&salesId=${sales_idField}`)
        .then(response => {
        if (!response.ok) {
            throw new Error('Error receiving SQ.');
        }
        else {
            return response.json();
        }
    })
        .catch(error => console.log(error));
    if (serviceQualificationObject.InternetBundlePlansWithOptions === null) {
        return false;
    }
    const serviceAddressObject = serviceQualificationObject.CQSAResponse.SubmitCQSAResult.ServiceAssessment.ServiceAddress;
    const requiredAddressFields = addressFieldsModel;
    const serviceAddressObjectFiltered = {};
    requiredAddressFields.forEach(field => serviceAddressObjectFiltered[field] = serviceAddressObject[field]);
    const dataBuild = {
        salesId: parseInt(sales_idField),
        organisationType: 1,
        address: serviceAddressObjectFiltered,
        token: tokenField,
    };
    const planData = qs.stringify(dataBuild, { arrayFormat: 'indices' });
    return yield getFullFibrePlans(planData, serviceAddressObject, sales_idField, tokenField);
});
export default getServiceQualification;
